var map = {
	"./Amex.svg": "ba1c",
	"./Diners.svg": "14f9",
	"./Elo.svg": "2a9f",
	"./Hipercard.svg": "43b5",
	"./Master.svg": "4e9e",
	"./Visa.svg": "d419"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d313";